const SYSTEM_NAME = 'Platform Visual Builder';

enum EVENT_TYPE {
  PAVE_VIEW = 'web_analytics.tracking.page_view.PageViewEvent',
  PARTNER_USER_INTERACTION = 'partner.app.platform.PartnerUserInteractionEvent',
  USER_INTERACTION = 'web_analytics.tracking.user_interaction.UserInteractionEvent',
}

export { EVENT_TYPE, SYSTEM_NAME };
